export default [
    /*{
        "id": "cart-2",
        "plugin": "cart",
        "pluginId": 13,
        "html": require('./carts/cart-2/html').default,
        "css": require('./carts/cart-2/css').default,
        "cssTablet": require('./carts/cart-2/cssTablet').default,
        "cssMobile": require('./carts/cart-2/cssMobile').default,
        "scss": require('./carts/cart-2/scss').default,
        "scssTablet": require('./carts/cart-2/scssTablet').default,
        "scssMobile": require('./carts/cart-2/scssMobile').default,
        "js": require('./carts/cart-2/js').default,
        "minJs": require('./carts/cart-2/minJs').default,
        "showOptions": true,
        "config": `{}`,
        "predefinedPlugin": {
            "plugin": "NewPromo",
            "pluginId": 1,
            "name": "cross-selling",
            "config": `{"Image":true,"TotalItems":8,"Type":5,"IncludeGroup":false}`
        },
        "pages": 'Order',
        "svgContent": require('./carts/cart-2/svgContent').default,
        "svgViewBox": "0 0 1440 600",
        "svgContentMobile": require('./carts/cart-2/svgContentMobile').default,
        "svgViewBoxMobile": "0 0 360 360"
    },*/
    {
        "id": "cart-1",
        "plugin": "cart",
        "pluginId": 13,
        "html": require('./carts/cart-1/html').default,
        "css": require('./carts/cart-1/css').default,
        "cssTablet": require('./carts/cart-1/cssTablet').default,
        "cssMobile": require('./carts/cart-1/cssMobile').default,
        "scss": require('./carts/cart-1/scss').default,
        "scssTablet": require('./carts/cart-1/scssTablet').default,
        "scssMobile": require('./carts/cart-1/scssMobile').default,
        "js": require('./carts/cart-1/js').default,
        "minJs": require('./carts/cart-1/minJs').default,
        "showOptions": true,
        "config": `{}`,
        "predefinedPlugin": {
            "plugin": "NewPromo",
            "pluginId": 1,
            "name": "cross-selling",
            "config": `{"Image":true,"TotalItems":8,"Type":5,"IncludeGroup":false}`
        },
        "pages": 'Order',
        "svgContent": require('./carts/cart-1/svgContent').default,
        "svgViewBox": "0 0 1440 1048",
        "svgContentMobile": require('./carts/cart-1/svgContentMobile').default,
        "svgViewBoxMobile": "0 0 360 1322"
    }
]